<template>
  <el-dialog
    v-model="dialogTableVisible"
    title="检测任务配置"
    fullscreen
    custom-class="dialog-title"
    style="background: #041938"
  >
    <el-container class="task-config-container">
      <!-- 左侧区域树 -->
      <el-aside width="200px" class="sidebar">
        <div class="sidebar-header">搜索区域</div>
        <el-tree
          class="region-tree"
          :data="regionData"
          :props="treeProps"
          node-key="id"
          default-expanded-keys="[1]"
          default-selected-keys="[1]"
          @node-click="handleRegionClick"
        />
      </el-aside>

      <!-- 右侧主内容区 -->
      <el-container class="main-content">
        <!-- 顶部筛选与操作栏 -->
        <el-header class="header-bar">
          <!-- <div class="header-title">安全帽检测 > 检测任务配置</div> -->
          <div class="filter-group">
            <!-- <el-select
              v-model="filterForm.cameraType"
              placeholder="请选择"
              class="filter-item"
              size="small"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="摄像头" value="1"></el-option>
              <el-option label="作业记录仪" value="2"></el-option>
            </el-select> -->
            <el-input
              v-model="filterForm.cameraName"
              placeholder="请输入记录仪名称"
              class="filter-item"
            />
            <el-input
              v-model="filterForm.cameraIp"
              placeholder="请输入记录仪编码"
              class="filter-item"
            />
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button type="info" @click="handleReset">重置</el-button>
          </div>
          <div class="action-group">
            <!-- <el-button type="primary" @click="handleBatchSelect"
              >批量选择</el-button
            > -->
            <el-button type="primary" @click="handleSave"
              >保存任务配置</el-button
            >
            <!-- <el-button type="primary" @click="handleStartTask"
              >开启任务</el-button
            >
            <el-button type="primary" @click="handleStopTask"
              >关闭任务</el-button
            >
            <el-button type="primary" @click="handleTimeSetting"
              >检测时间设置</el-button
            > -->
          </div>
        </el-header>

        <!-- 摄像头卡片网格 -->
        <el-main class="content-body">
          <div class="camera-grid">
            <div
              class="camera-card"
              v-for="camera in cameraList"
              :key="camera.id"
              :class="{ active: camera.isActive }"
            >
              <!-- 缩略图区域 -->
              <div class="camera-thumb">
                <el-image :src="camera.thumbUrl" fit="cover" class="thumb-img">
                  <template #error>
                    <div class="image-slot">暂无画面</div>
                  </template>
                </el-image>
                <!-- 右上角名称标签 -->
                <div class="camera-name-tag">{{ camera.name }}</div>
              </div>

              <!-- 操作按钮区域 -->
              <div class="camera-actions">
                <div class="action-item">
                  <span>绘制监控区域</span>
                  <el-switch
                    v-model="camera.drawRegion"
                    size="small"
                    active-color="#00ccff"
                    @change="() => handleDrawRegion(camera)"
                  />
                  <el-button
                    icon="CircleClose"
                    size="small"
                    type="text"
                    class="close-btn"
                  ></el-button>
                </div>
                <div class="action-item">
                  <span>检测时间设置：</span>
                  <el-button
                    icon="Setting"
                    size="small"
                    type="text"
                    @click="handleTimeConfig(camera)"
                  ></el-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination-wrapper">
            <el-pagination
              v-model:current-page="pagination.pageNum"
              v-model:page-size="pagination.pageSize"
              :page-sizes="[10, 20, 50]"
              :total="pagination.total"
              layout="prev, pager, next, jumper"
              size="small"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
            />
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-dialog>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { CircleClose, Setting } from "@element-plus/icons-vue";
const dialogTableVisible = ref(false);
const openDialog = () => {
  dialogTableVisible.value = true;
};
// 左侧区域树数据
const regionData = ref([
  {
    id: 1,
    label: "中国石油",
    children: [
      { id: 11, label: "北京石油" },
      { id: 12, label: "成都石油" },
    ],
  },
]);

const treeProps = ref({
  children: "children",
  label: "label",
});

// 筛选表单
const filterForm = reactive({
  cameraType: "",
  cameraName: "",
  cameraIp: "",
});

// 分页配置
const pagination = reactive({
  pageNum: 1,
  pageSize: 10,
  total: 10,
});

// 摄像头列表数据（模拟截图中的数据）
const cameraList = ref([
  {
    id: 1,
    name: "IPC",
    thumbUrl: "", // 空值会显示占位图
    isActive: false,
    drawRegion: false,
  },
  {
    id: 2,
    name: "aaaaa",
    thumbUrl: "https://picsum.photos/200/120?random=1",
    isActive: false,
    drawRegion: false,
  },
  {
    id: 3,
    name: "IPC32",
    thumbUrl: "https://picsum.photos/200/120?random=2",
    isActive: true, // 截图中高亮的卡片
    drawRegion: true, // 截图中开启的开关
  },
  {
    id: 4,
    name: "Channel0",
    thumbUrl: "https://picsum.photos/200/120?random=3",
    isActive: false,
    drawRegion: false,
  },
  {
    id: 5,
    name: "ddddd123+++",
    thumbUrl: "https://picsum.photos/200/120?random=4",
    isActive: false,
    drawRegion: false,
  },
  {
    id: 6,
    name: "A1作业记录仪1",
    thumbUrl: "https://picsum.photos/200/120?random=5",
    isActive: false,
    drawRegion: false,
  },
  {
    id: 7,
    name: "运行保障部5G",
    thumbUrl: "https://picsum.photos/200/120?random=6",
    isActive: false,
    drawRegion: false,
  },
  {
    id: 8,
    name: "csssa",
    thumbUrl: "https://picsum.photos/200/120?random=7",
    isActive: false,
    drawRegion: false,
  },
  {
    id: 9,
    name: "KEDA作业记录仪",
    thumbUrl: "https://picsum.photos/200/120?random=8",
    isActive: false,
    drawRegion: false,
  },
  {
    id: 10,
    name: "Alarmin",
    thumbUrl: "https://picsum.photos/200/120?random=9",
    isActive: false,
    drawRegion: false,
  },
]);

// 事件处理函数
const handleRegionClick = (data) => {
  ElMessage.info(`已选择区域：${data.label}`);
};

const handleSearch = () => {
  ElMessage.info("搜索功能执行");
};

const handleReset = () => {
  filterForm.cameraType = "";
  filterForm.cameraName = "";
  filterForm.cameraIp = "";
};

const handleBatchSelect = () => {
  ElMessage.info("批量选择功能开发中");
};

const handleSave = () => {
  ElMessage.success("任务配置保存成功");
};

const handleStartTask = () => {
  ElMessage.success("任务已开启");
};

const handleStopTask = () => {
  ElMessage.warning("任务已关闭");
};

const handleTimeSetting = () => {
  ElMessage.info("检测时间设置弹窗打开");
};

const handleDrawRegion = (camera) => {
  ElMessage.info(
    `${camera.name} 绘制监控区域：${camera.drawRegion ? "开启" : "关闭"}`,
  );
};

const handleTimeConfig = (camera) => {
  ElMessage.info(`配置 ${camera.name} 的检测时间`);
};

const handleSizeChange = (val) => {
  pagination.pageSize = val;
};

const handleCurrentChange = (val) => {
  pagination.pageNum = val;
};
defineExpose({
  openDialog,
});
</script>

<style lang="scss" scoped>
// 全局布局
.task-config-container {
  height: 880px;
  background-color: #0a1020;
  color: #e5e9f0;

  .sidebar {
    background: linear-gradient(180deg, #0f1a30 0%, #050b1a 100%);
    border-right: 1px solid #1a3a6a;
    color: #b0c8e8;

    .sidebar-header {
      padding: 12px 16px;
      font-size: 14px;
      font-weight: 600;
      background-color: #14305c;
      border-bottom: 1px solid #1a3a6a;
    }
    :deep(.el-text) {
      --el-text-color: #fff;
    }
    .region-tree {
      --el-tree-text-color: #b0c8e8;
      --el-tree-node-hover-bg-color: #16325e;
      --el-tree-node-selected-bg-color: #0066cc;
      --el-tree-node-selected-text-color: #ffffff;

      padding: 10px;
      background-color: #06153d;
    }
  }

  .main-content {
    display: flex;
    flex-direction: column;

    // 顶部栏
    .header-bar {
      height: auto;
      padding: 12px 20px;
      background-color: #0f1a30;
      border-bottom: 1px solid #1a3a6a;
      display: flex;
      flex-direction: column;
      gap: 12px;

      .header-title {
        font-size: 15px;
        font-weight: 600;
        color: #ffffff;
      }

      .filter-group {
        display: flex;
        gap: 10px;
        align-items: center;

        .filter-item {
          width: 180px;
        }
      }

      .action-group {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
      }
    }

    // 内容主体
    .content-body {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
      background-color: #0a1020;

      // 摄像头网格
      .camera-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 16px;
        margin-bottom: 20px;
      }

      // 摄像头卡片
      .camera-card {
        background-color: #0f1a30;
        border: 1px solid #1a3a6a;
        border-radius: 6px;
        overflow: hidden;
        transition: all 0.3s ease;

        // 激活态（截图中IPC32的样式）
        &.active {
          border-color: #00ccff;
          box-shadow: 0 0 15px rgba(0, 204, 255, 0.3);
        }

        .camera-thumb {
          position: relative;
          height: 120px;
          border-bottom: 1px solid #1a3a6a;

          .thumb-img {
            width: 100%;
            height: 100%;
          }

          .image-slot {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            background-color: #050b1a;
            color: #6b7280;
          }

          .camera-name-tag {
            position: absolute;
            top: 4px;
            right: 4px;
            background-color: rgba(15, 26, 48, 0.8);
            color: #ffffff;
            padding: 2px 8px;
            font-size: 12px;
            border-radius: 4px;
            backdrop-filter: blur(2px);
          }
        }

        .camera-actions {
          padding: 8px 10px;
          font-size: 12px;
          color: #b0c8e8;

          .action-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 6px;

            &:last-child {
              margin-bottom: 0;
            }

            .close-btn {
              color: #6b7280;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}

// Element Plus 全局深色适配
:deep {
  .el-input,
  .el-select {
    --el-input-bg-color: #14305c;
    --el-input-border-color: #1a3a6a;
    --el-input-text-color: #ffffff;
    --el-input-placeholder-color: #8aa2c2;
    --el-input-hover-border-color: #00ccff;
  }

  .el-button {
    --el-button-text-color: #ffffff;
    --el-button-disabled-text-color: #6b7280;
  }

  .el-button--primary {
    --el-button-bg-color: #0066cc;
    --el-button-border-color: #0066cc;
    --el-button-hover-bg-color: #0099ff;
  }

  .el-switch {
    --el-switch-on-color: #00ccff;
    --el-switch-off-color: #4b5563;
  }
}
</style>
